module.exports = __webpack_public_path__ + "img/CRT_Weapon-Sword-04.4b3b8ea3.png";